"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TaskFilter = require("./TaskFilter");

var _TaskFilter2 = _interopRequireDefault(_TaskFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TaskFilter2.default;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-task-filter@0.0.19@@alicd/crui-task-filter/lib/index.js
// module id = 715
// module chunks = 0